import { useRouter } from 'next/router'
import type { QueryType } from 'shared/route-query/types/route-query-interface'
import type { OrderEnum } from 'shared/types/swr-pagination-interface'

interface PaginationQuery {
  startFromId: number | string | undefined
  order: OrderEnum | undefined
  limit: number | undefined
}

export const usePaginationQuery = (): PaginationQuery => {
  const { query } = useRouter()

  const { startFromId, order, limit } = query as QueryType
  return {
    startFromId: startFromId || undefined,
    order,
    limit: limit && Number(limit),
  }
}
